<template>
  <v-row>
    <v-col cols="5">
      <v-row no-gutters style="text-align: left; justify-content: space-between;">
        <v-col cols="auto">
          <span class="text-body-2" :class="{ 'text--disabled': !isModuleEnabled }">
            {{ $i18n.t('admin.smsGatewayName') }}:
          </span>
        </v-col>
        <v-col cols="auto">
          <span class="text-body-2" :class="{ 'text--disabled': !isModuleEnabled }">
            {{ smsProviderName }}
          </span>
        </v-col>
      </v-row>
      <v-row no-gutters class="align-baseline">
        <v-col cols="auto" style="flex-grow: 1;">
          <data-input v-bind="phoneNumberParams" v-model="phoneNumber" :disabled="!isModuleEnabled"> </data-input>
        </v-col>
        <v-col cols="auto" class="pl-10">
          <v-row no-gutters class="justify-start">
            <template v-if="!isSmsSent">
              <v-col cols="auto" class="sms-button-wrapper">
                <base-button
                  :disabled="!isValidPhoneNumber || !isModuleEnabled"
                  @click="sendSmsHandler"
                  translation-path="admin.sendTestSms"
                  :loading="loading"
                ></base-button>
              </v-col>
            </template>
            <template v-else>
              <v-col>
                <v-row no-gutters>
                  <v-col cols="auto">
                    <v-icon color="success">
                      mdi-check
                    </v-icon>
                  </v-col>
                  <v-col cols="auto" class="success--text">
                    {{ $i18n.t('admin.smsSent') }}
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="auto" class="pl-5">
                    <link-underlined @click="sendSmsHandler" translation-path="admin.sendAgain"> </link-underlined>
                  </v-col>
                </v-row>
              </v-col>
            </template>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { call, get } from 'vuex-pathify';

import DataInput from '@/components/DataInput';
import LinkUnderlined from '@/components/LinkUnderlined';

export default {
  name: 'SmsSettings',
  components: {
    DataInput,
    LinkUnderlined,
  },
  data: () => ({
    isSmsSent: false,
    loading: false,
    phoneNumber: null,
    phoneNumberParams: {
      dataType: {
        name: 'text',
      },
      hint: 'admin.phoneNumberHint',
    },
  }),
  computed: {
    additionalModuleName: get('admin/additionalModules@SMS.verbose_name'),
    isModuleEnabled: get('admin/settingsValues@sms_module_enabled'),
    smsProviderName: get('admin/settingsValues@sms_api_provider_name'),
    isValidPhoneNumber() {
      return /(?:(?:(?:\+|00)?48)|(?:\(\+?48\)))?(?:1[2-8]|2[2-69]|3[2-49]|4[1-8]|5[0-9]|6[0-35-9]|[7-8][1-9]|9[145])\d{7}/.test(
        this.phoneNumber
      );
    },
  },
  watch: {
    isModuleEnabled(nV) {
      if (!nV) {
        this.isSmsSent = false;
      }
    },
  },
  methods: {
    sendSms: call('sms/sendTestSms'),
    async sendSmsHandler() {
      try {
        this.loading = true;
        await this.sendSms({
          phone_number: this.phoneNumber,
        });
        setTimeout(() => {
          this.loading = false;
          this.isSmsSent = true;
        }, 500);
        if (this.isSmsSent) {
          this.$store.set('snackbar/PUSH_SUCCESSFULLY_MESSAGE!', {
            message: this.$i18n.t('success.sendSms'),
          });
        }
      } catch (error) {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .sms-button-wrapper .v-btn {
  margin: 0 !important;
}
</style>
